export const openInNewTab = url => {
  const win = window.open(url, '_self');
  win.focus();
};

export const navigateTo = url => {
  window.location.href = url;
};
